var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeofenceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 175,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "currentLayer"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4733",
    d: "M0 87.5C0 39.157 39.381 0 88 0s88 39.157 88 87.5S136.619 175 88 175 0 135.843 0 87.5z",
    className: "selected"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofenceIcon);
export default __webpack_public_path__ + "static/media/geofence-icon.68d6deaf881230d68816446077148f4f.svg";
export { ForwardRef as ReactComponent };